import sessionProvider from "../../../shared/utils/session";

const { hasTokenStored, getUserData, setUserData, getToken, guardar, borrar } = sessionProvider.create(sessionStorage);

export const userData = () => getUserData();
export const setSessionUserData = data => {
  setUserData(data);
};

export const isAuthenticated = () => {
  return hasTokenStored();
};

export const doLogout = cb => {
  borrar();
  cb && cb();
};